import { render, staticRenderFns } from "./enrollment.vue?vue&type=template&id=705015a6&"
import script from "./enrollment.vue?vue&type=script&lang=js&"
export * from "./enrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705015a6')) {
      api.createRecord('705015a6', component.options)
    } else {
      api.reload('705015a6', component.options)
    }
    module.hot.accept("./enrollment.vue?vue&type=template&id=705015a6&", function () {
      api.rerender('705015a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/enrollment.vue"
export default component.exports